import { Box, BoxProps, Image } from '@chakra-ui/react';
import { IdlescapeWrappingTooltip } from '@idlescape/ui';
import React from 'react';
import { useSetRecoilState } from 'recoil';
import { shareQuestSelector } from '../../../atoms/chat/chatHistoryAtom';

export default function QuestShareButton({
	questID,
	type,
	...props
}: {
	questID: number;
	type: 'achievement' | 'quest';
} & BoxProps) {
	const shareQuest = useSetRecoilState(shareQuestSelector);
	return (
		<IdlescapeWrappingTooltip content={`Share your ${type} progress!`}>
			<Box
				className='share-achievement-button'
				onClick={() => shareQuest(questID.toString())}
				filter='drop-shadow(3px 3px 2px rgba(0, 0, 0, 0.9))'
				cursor='pointer'
				position='absolute'
				top='10px'
				right='10px'
				zIndex='11'
				_hover={{ filter: 'brightness(2)' }}
				{...props}
			>
				<Image src='/images/chaticons/chat-icon-global.png' width='100%' height='100%' />
			</Box>
		</IdlescapeWrappingTooltip>
	);
}
